export default {
  queryParams: {},
  transcoderEnvironment: {},
  cardTab: 0,
  token: null,
  teacherId: null,
  bulbId: null,
  interactionId: null,
  lessonId: null,
  bulbAttemptId: null,
  questionId: null,
  keyboardFocus: false,
  userAgent: {
    browser: {},
    cpu: {},
    device: {},
    engine: {},
    os: {
      name: '',
    },
  },
  transcoderSize: null,
  hostingLog: {
    currentHostingSeconds: 0,
    totalHostingSeconds: 0,
    decimal: 0,
    percentage: 0,
  },
  loading: {
    enabled() {
      return !!this.loadings.length;
    },
    status() {
      if (!this.loadings || !this.loadings.length) return false;
      else if (this.loadings.every((l) => l.status === 'success')) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.loadings = [];
        }, 1000);
        return 'success';
      } else if (this.loadings.some((l) => l.status === 'error')) return 'error';
      return true;
    },
    progress() {
      if (!this.loadings || !this.loadings.length) return false;
      const totalProgress = this.loadings
        .map((l) => l.progress)
        .reduce((a, curr) => a + curr);
      return ((totalProgress / (this.loadings.length * 100)) * 100);
    },
    active() {
      return this.loadings.find((l) => l.status === true || l.status === 'error') || {};
    },
    activeIndex() {
      return this.loadings.findIndex((l) => l.status === true);
    },
    loadings: [],
  },
  error: {},
  generateRandomNumber(min = 0, max = 1000000000) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },
};